import { Injectable } from '@angular/core';
import { HttpGeneralService, OutpatientParms } from '../../shared';
import { CONFIG } from '../../shared/config';
const salesOrderHistoryUrl = CONFIG.baseUrls.salesOrderHistory;
 

@Injectable({
  providedIn: 'root'
})
export class SalesOrderHistoryPopUpService {

  constructor(private _httpGeneralService: HttpGeneralService) { }

  getSalesOrderList(searchObj: OutpatientParms) {
    return this._httpGeneralService.add(searchObj, `${salesOrderHistoryUrl}/getSalesOrderList`);
  }

  getSalesOrderDetail(reservationsList: OutpatientParms) {
    return this._httpGeneralService.add(reservationsList, `${salesOrderHistoryUrl}/getSalesOrderDetail`);
  }
}
